export const getCookie = (name) => {
  let v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)")

  return v ? v[2] : null
}

export const setCookie = (name, value, milliseconds = 24 * 60 * 60 * 1000 * 360) => {
  let d = new Date()
  d.setTime(d.getTime() + milliseconds)
  let domainValue =
    name === "auth_access_mpo" || name === "auth_refresh_mpo"
      ? "; domain=" + process.env.VUE_APP_MPO_DOMAIN
      : ""

  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + domainValue
}

export const deleteCookie = (name) => setCookie(name, "", -1)
